<template>
  <div>
    <div class="mobile-tab-list">
      <slot name="tablist" />
    </div>
    <div class="mobile-tab-content">
      <slot name="tabcontent" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-tab-list {
  width: 100%;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
  background-color: #ffffff;
  border-bottom: 2px solid #e7eaec;
}
.mobile-tab-content {
  height: calc(100vh - #{$mobile-nav-size} - 50px);
  overflow: auto;
}
</style>


<script>
import _ from 'lodash'

export default {
  name: 'MobileTabbedPage',
  provide() {
    return {
      mobileTabbedPage: this
    }
  },
  data() {
    return {
      registeredTabItems: [],
      registeredTabContentItems: [],
    }
  },
  methods: {
    showTab(tabItem) {
      var index = _.findIndex(this.registeredTabItems, i => i == tabItem)

      this.registeredTabItems.forEach((tab, tabIndex) => {
        tab.active = index == tabIndex
      })
      this.registeredTabContentItems.forEach((tab, tabIndex) => {
        tab.active = index == tabIndex
      })
    },
    registerTabItem(item) {
      if(!this.registeredTabItems.find(i => i === item)) {
        this.registeredTabItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTabItem(item)
        })
        item.active = this.registeredTabItems.length == 1
      }
    },
    unregisterTabItem(item) {
      this.registeredTabItems = this.registeredTabItems.slice().filter(i => i !== item)
    },
    registerTabContentItem(item) {
      if(!this.registeredTabContentItems.find(i => i === item)) {
        this.registeredTabContentItems.push(item)
        item.$once('hook:destroyed', () => {
          this.unregisterTabContentItem(item)
        })
        item.active = this.registeredTabContentItems.length == 1
      }
    },
    unregisterTabContentItem(item) {
      this.registeredTabContentItems = this.registeredTabContentItems.slice().filter(i => i !== item)
    }
  }
}
</script>